import React from 'react';
const TOTAL_SPOTS = 100;
const CLAIMED_SPOTS = 93;
export function ScarcityBar() {
  const left = TOTAL_SPOTS - CLAIMED_SPOTS;
  const pct = Math.round(CLAIMED_SPOTS / TOTAL_SPOTS * 100);
  return <div data-id="element-72" data-mp="2l5pna1o200ag">
      <div className="flex items-center justify-between gap-3 text-sm font-bold text-white" data-id="element-73" data-mp="2l3v5gw82woal">
        <span className="flex items-center gap-2" data-id="element-74" data-mp="2q2zbjdzpi5wp">
          <span className="relative flex h-2.5 w-2.5" aria-hidden="true" data-id="element-75" data-mp="2q1o9bilwt67p">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-urgent opacity-75" data-id="element-76" data-mp="2b5fa2h20qsva" />
            <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-urgent" data-id="element-77" data-mp="2g3ql2v41v9f3" />
          </span>
          Only {left} spots left at $27
        </span>
        <span className="text-urgent" data-id="element-78" data-mp="2766fj9z5mqyo">{pct}% claimed</span>
      </div>
      <div className="mt-2.5 h-4 overflow-hidden rounded-full bg-white/10" role="progressbar" aria-valuemin={0} aria-valuemax={TOTAL_SPOTS} aria-valuenow={CLAIMED_SPOTS} aria-label="Promotional spots claimed" data-id="element-79" data-mp="eypky03enph">
        <div className="h-full rounded-full bg-urgent" style={{
        width: `${pct}%`
      }} data-id="element-80" data-mp="33ks8dbfgm9pe" />
      </div>
      <p className="mt-2 text-xs text-white/60" data-id="element-81" data-mp="2zj7063dvejlj">
        {CLAIMED_SPOTS} of {TOTAL_SPOTS} promotional spots already claimed. When they run out, the $27 price ends.
      </p>
    </div>;
}